import { useState, useEffect, useContext } from 'react';
import { StyleContext } from 'utils/context/StyleContextProvider';
import classNames from 'classnames';
import throttle from 'lodash/throttle';
import styles from './ProgressBar.module.scss';

export default function ProgressBar() {
    const parentStyles = useContext(StyleContext),
        [scroll, setScroll] = useState(0),
        handleScroll = throttle(
            async ({
                target: {
                    documentElement: { scrollHeight, scrollTop, clientHeight },
                },
            }) => {
                const totalScroll = scrollTop,
                    windowHeight = scrollHeight - clientHeight,
                    scroll = `${totalScroll / windowHeight}`;

                setScroll(scroll);
            },
            500,
        );

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    });

    return (
        <div
            className={classNames('fixed inset-0 z-10 h-1 w-full', [
                styles.pbWrapper,
                parentStyles?.pbWrapper,
            ])}
        >
            <div
                className={classNames('h-1', [
                    styles.progressBar,
                    parentStyles?.progressBar,
                ])}
                style={{
                    transform: `scale(${scroll}, 1)`,
                    opacity: `${scroll * 1.25}`,
                }}
            />
        </div>
    );
}
